import { HostListener, Component, ViewChild, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';

@Component({
  selector: 'app-top-display-pannel',
  templateUrl: './top-display-pannel.component.html',
  styleUrls: ['./top-display-pannel.component.css']
})
/** TopDisplayPannel component*/
export class TopDisplayPannelComponent implements OnInit {
  @Output() newItemEvent = new EventEmitter<{ DefectSatuses: string }>();
  @Output() newItemEvent1 = new EventEmitter<{ RCPStatus: string }>();
  @Output() newItemEvent2 = new EventEmitter<{ DueStatuses: string }>();
  MainHeader: any;
  cardheader1: any;
  cardheader2: any;
  cardheader3: any;

  value1: any;
  value2: any;
  value3: any;
  totalStatus: any;
  totalpriority: any;
  totalRCAStatus: any;
  totaloverdue: any;
  header: any;


  /** TopDisplayPannel ctor */
  constructor(private router: Router, http: HttpClient) {

  }
  ngOnInit(): void {

  }

  addNewItem(DefectSatuses) {
    this.newItemEvent.emit({ DefectSatuses });
  }
  addNewItem1(RCPStatus) {
    this.newItemEvent1.emit({ RCPStatus });
  }
  addNewItem2(DueStatuses) {
    this.newItemEvent2.emit({ DueStatuses });
  }
}
